export const LOGIN_ROUTE = '/';
export const REGISTER_ROUTE = '/register';
export const TERMS_AND_CONDITONS_ROUTE = '/terms-and-conditions';
export const SUCCESS_ROUTE = '/success';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const NEW_PASSWORD_ROUTE = '/new-password';
export const DASHBOARD_ROUTE = '/dashboard';
export const ALL_FILE_ROUTE = '/files/all-files';
export const MY_FILE_ROUTE = '/files/my-files';
export const CGA_FILE_ROUTE = '/files/cga-files';
export const PERSONAL_INFORMATION_ROUTE = '/profile/personal-information';
export const EDITOR_ROUTE = '/editor/:id';
export const VENDORS_ROUTE = '/vendors';
